webpackJsonp([163113943535049],{

/***/ 1179:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 939:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _qs = __webpack_require__(58);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _domFormSerializer = __webpack_require__(56);
	
	var _Select = __webpack_require__(600);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Icons = __webpack_require__(63);
	
	var _reactRouter = __webpack_require__(1318);
	
	__webpack_require__(1179);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Application = function (_React$Component) {
	  _inherits(Application, _React$Component);
	
	  function Application(props) {
	    _classCallCheck(this, Application);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.componentDidMount = function () {
	      var queryString = _qs2.default.parse(_this.props.location.search, { ignoreQueryPrefix: true });
	
	      if (queryString.submit) {
	
	        setTimeout(function () {
	          window.scrollTo({
	            top: _this.formRef.current.offsetTop
	          });
	        }, 100);
	      }
	    };
	
	    _this.handleUpload = function (event, target) {
	      var _this$setState;
	
	      var fileNames = [];
	
	      var file = event.target.files ? Array.from(event.target.files).forEach(function (file) {
	        fileNames.push(file.name);
	      }) : _this.state[target];
	
	      _this.setState((_this$setState = {}, _this$setState[target] = !!fileNames.length ? fileNames.join(', ') : file, _this$setState));
	    };
	
	    _this.handleSubmit = function (e) {
	      e.preventDefault();
	      var formTarget = e.target;
	
	      if (_this.state.disabled) return;
	      var form = e.target;
	      var data = (0, _domFormSerializer.serialize)(form);
	
	      _this.setState({
	        filesUploading: true
	      }, function () {
	        formTarget.submit();
	      });
	    };
	
	    _this.formRef = _react2.default.createRef();
	
	    _this.state = {
	      alert: '',
	      disabled: false
	    };
	    return _this;
	  }
	
	  Application.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        name = _props.name,
	        subject = _props.subject,
	        action = _props.action,
	        formName = _props.formName,
	        active = _props.active,
	        fields = _props.fields;
	    var _fields$emailaddress = fields.emailaddress,
	        emailaddress = _fields$emailaddress === undefined ? '' : _fields$emailaddress,
	        _fields$yourname = fields.yourname,
	        yourname = _fields$yourname === undefined ? '' : _fields$yourname,
	        _fields$phone = fields.phone,
	        phone = _fields$phone === undefined ? '' : _fields$phone,
	        _fields$role = fields.role,
	        role = _fields$role === undefined ? '' : _fields$role,
	        _fields$qualification = fields.qualifications,
	        qualifications = _fields$qualification === undefined ? '' : _fields$qualification,
	        _fields$message = fields.message,
	        message = _fields$message === undefined ? '' : _fields$message,
	        centre = fields.centre;
	
	
	    var queryString = _qs2.default.parse(this.props.location.search, { ignoreQueryPrefix: true });
	
	    return _react2.default.createElement(
	      'form',
	      {
	        className: 'ApplicationForm ' + (active ? 'active' : ''),
	        name: formName,
	        action: '?submit=true',
	        method: 'post',
	        onSubmit: this.handleSubmit,
	        'data-netlify': '',
	        'netlify-honeypot': '_gotcha',
	        encType: 'multipart/form-data',
	        ref: this.formRef
	      },
	      queryString.submit && _react2.default.createElement(
	        'div',
	        { className: 'EnquiryForm--Alert' },
	        'Thanks for your submission, we will get back to you soon'
	      ),
	      _react2.default.createElement(
	        'label',
	        { className: 'EnquiryForm--Label' },
	        _react2.default.createElement('input', {
	          className: 'EnquiryForm--Input',
	          type: 'text',
	          placeholder: 'Your Name',
	          name: 'yourname',
	          value: yourname,
	          onChange: this.props.handleChange,
	          required: true
	        })
	      ),
	      _react2.default.createElement(
	        'label',
	        { className: 'EnquiryForm--Label' },
	        _react2.default.createElement('input', {
	          className: 'EnquiryForm--Input',
	          type: 'text',
	          placeholder: 'Phone',
	          name: 'phone',
	          value: phone,
	          onChange: this.props.handleChange,
	          required: true
	        })
	      ),
	      _react2.default.createElement(
	        'label',
	        { className: 'EnquiryForm--Label' },
	        _react2.default.createElement('input', {
	          className: 'EnquiryForm--Input',
	          type: 'email',
	          placeholder: 'Email',
	          name: 'emailaddress',
	          value: emailaddress,
	          onChange: this.props.handleChange,
	          required: true
	        })
	      ),
	      _react2.default.createElement(
	        'label',
	        { className: 'EnquiryForm--Label' },
	        _react2.default.createElement('input', {
	          className: 'EnquiryForm--Input',
	          type: 'text',
	          placeholder: 'Preferred Role',
	          name: 'role',
	          value: role,
	          onChange: this.props.handleChange,
	          required: true
	        })
	      ),
	      _react2.default.createElement(_Select2.default, {
	        placeholder: 'Preferred Centre',
	        name: 'centre',
	        handleChange: this.props.handleChange,
	        options: ['East Malvern Learning Centre', 'Mildura Early Learning Centre', 'Mildura Central Early Learning Centre'],
	        selectedOption: centre
	      }),
	      _react2.default.createElement(_Select2.default, {
	        placeholder: 'Joining as',
	        name: 'type',
	        handleChange: this.props.handleChange,
	        options: ['Room Leader', 'Diploma Qualified Educator', 'Certificate 3 Qualified Educator', 'Unqualified Educator – working towards qualification', 'Cook']
	      }),
	      _react2.default.createElement(
	        'label',
	        { className: 'EnquiryForm--Label full-width' },
	        _react2.default.createElement('input', {
	          className: 'EnquiryForm--Input',
	          type: 'text',
	          placeholder: 'Qualifications',
	          name: 'qualifications',
	          value: qualifications,
	          onChange: this.props.handleChange,
	          required: true
	        })
	      ),
	      _react2.default.createElement(
	        'label',
	        { className: 'EnquiryForm--Label full-width word-wrap' },
	        _react2.default.createElement('input', {
	          className: 'EnquiryForm--Input',
	          type: 'text',
	          placeholder: 'Why do you want to work for Great Start?',
	          name: 'message',
	          value: message,
	          onChange: this.props.handleChange,
	          required: true
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'file-download' },
	        _react2.default.createElement(
	          'div',
	          { className: 'file-download-items' },
	          _react2.default.createElement(
	            'div',
	            { className: 'file-download-item' },
	            _react2.default.createElement(
	              'label',
	              { className: 'EnquiryForm--Label title' },
	              _react2.default.createElement('input', {
	                className: 'EnquiryForm--Input',
	                type: 'file',
	                placeholder: 'Resume',
	                name: 'resume',
	                onChange: function onChange(event) {
	                  return _this2.handleUpload(event, 'resume');
	                },
	                required: true
	              }),
	              'Resume ',
	              _react2.default.createElement(_Icons.ICONUpload, null)
	            ),
	            this.state.resume && _react2.default.createElement(
	              'p',
	              { className: 'results' },
	              this.state.resume
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'file-download-item' },
	            _react2.default.createElement(
	              'label',
	              { className: 'EnquiryForm--Label title' },
	              _react2.default.createElement('input', {
	                className: 'EnquiryForm--Input',
	                type: 'file',
	                placeholder: 'Cover Letter',
	                name: 'coverLetter',
	                onChange: function onChange(event) {
	                  return _this2.handleUpload(event, 'coverLetter');
	                },
	                required: true
	              }),
	              'Cover Letter ',
	              _react2.default.createElement(_Icons.ICONUpload, null)
	            ),
	            this.state.coverLetter && _react2.default.createElement(
	              'p',
	              { className: 'results' },
	              this.state.coverLetter
	            )
	          )
	        )
	      ),
	      _react2.default.createElement('input', { type: 'text', name: '_gotcha', style: { display: 'none' } }),
	      !!subject && _react2.default.createElement('input', { type: 'hidden', name: 'subject', value: subject }),
	      _react2.default.createElement('input', { type: 'hidden', name: 'form-name', value: formName }),
	      _react2.default.createElement('input', {
	        className: 'Button hasShadowHover EnquiryForm--SubmitButton',
	        type: 'submit',
	        value: 'Submit',
	        disabled: this.state.disabled
	      })
	    );
	  };
	
	  return Application;
	}(_react2.default.Component);
	
	Application.defaultProps = {
	  name: 'Application',
	  subject: '', // optional subject of the notification email
	  action: '',
	  successMessage: 'Thanks for your submission, we will get back to you soon',
	  errorMessage: 'There is a problem, your message has not been sent, please try contacting us via email'
	};
	exports.default = (0, _reactRouter.withRouter)(Application);
	module.exports = exports['default'];

/***/ }),

/***/ 940:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ApplicationForm = __webpack_require__(939);
	
	var _ApplicationForm2 = _interopRequireDefault(_ApplicationForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BookingSection = function (_Component) {
		_inherits(BookingSection, _Component);
	
		function BookingSection() {
			var _temp, _this, _ret;
	
			_classCallCheck(this, BookingSection);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
				fields: {
					centre: 'East Malvern Learning Centre'
				}
			}, _this.handleChange = function (e) {
				if (e.persist && {}.toString.call(e.persist) === '[object Function]') {
					e.persist();
				}
	
				_this.setState(function (prevState) {
					var _extends2;
	
					return {
						fields: _extends({}, prevState.fields, (_extends2 = {}, _extends2[e.target.name] = e.target.value, _extends2))
					};
				});
			}, _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		BookingSection.prototype.render = function render() {
			var _this2 = this;
	
			var _props = this.props,
			    name = _props.name,
			    subject = _props.subject,
			    action = _props.action;
	
	
			var centres = ['East Malvern Learning Centre', 'Mildura Early Learning Centre', 'Mildura Central Early Learning Centre'];
	
			var fields = this.state.fields;
			var centre = fields.centre;
	
	
			return _react2.default.createElement(
				'div',
				{ className: 'bookingsection' },
				_react2.default.createElement(
					'div',
					{ className: 'container' },
					centres.map(function (centreItem, index) {
						return _react2.default.createElement(_ApplicationForm2.default, {
							key: centreItem + index,
							active: centre === centreItem,
							formName: centreItem + ' Application Form',
							fields: fields,
							handleChange: _this2.handleChange
						});
					})
				)
			);
		};
	
		return BookingSection;
	}(_react.Component);
	
	exports.default = BookingSection;
	module.exports = exports['default'];

/***/ }),

/***/ 696:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 600:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Icons = __webpack_require__(63);
	
	__webpack_require__(696);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Select = function (_Component) {
	  _inherits(Select, _Component);
	
	  function Select(props) {
	    _classCallCheck(this, Select);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.selectRef = _react2.default.createRef();
	
	    _this.state = {};
	    return _this;
	  }
	
	  Select.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    if (prevState.active !== this.state.active) {
	      this.props.handleChange({
	        target: {
	          name: this.selectRef.current.name,
	          value: this.selectRef.current.value
	        }
	      });
	    }
	  };
	
	  Select.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        name = _props.name,
	        options = _props.options,
	        placeholder = _props.placeholder,
	        handleChange = _props.handleChange,
	        selectedOption = _props.selectedOption;
	    var _state = this.state,
	        active = _state.active,
	        _state$activeDropdown = _state.activeDropdown,
	        activeDropdown = _state$activeDropdown === undefined ? false : _state$activeDropdown;
	
	
	    return _react2.default.createElement(
	      'label',
	      { className: 'EnquiryForm--Label' },
	      _react2.default.createElement(
	        'select',
	        { style: { display: 'none' }, name: name, ref: this.selectRef },
	        options.map(function (option, index) {
	          return _react2.default.createElement(
	            'option',
	            { key: option, value: option, selected: option === selectedOption ? true : false },
	            option
	          );
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'select-dropdown ' + (activeDropdown ? 'active' : '') },
	        _react2.default.createElement(
	          'p',
	          { className: 'EnquiryForm--Input has-arrow', onClick: function onClick() {
	              return _this2.setState({ activeDropdown: !activeDropdown });
	            } },
	          active ? active : placeholder,
	          ' ',
	          _react2.default.createElement(_Icons.ICONArrowDown, null)
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          options.map(function (option) {
	            return _react2.default.createElement(
	              'li',
	              {
	                key: option,
	                onClick: function onClick() {
	                  return _this2.setState({ active: option, activeDropdown: false });
	                },
	                className: option === active ? 'active' : ''
	              },
	              option
	            );
	          })
	        )
	      )
	    );
	  };
	
	  return Select;
	}(_react.Component);
	
	exports.default = Select;
	module.exports = exports['default'];

/***/ }),

/***/ 432:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 956:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = exports.EmploymentOpportunitiesTemplate = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(9);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _get2 = __webpack_require__(14);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _PageHeader = __webpack_require__(15);
	
	var _PageHeader2 = _interopRequireDefault(_PageHeader);
	
	var _Content = __webpack_require__(6);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _ApplicationFormSection = __webpack_require__(940);
	
	var _ApplicationFormSection2 = _interopRequireDefault(_ApplicationFormSection);
	
	var _ExceedBanner = __webpack_require__(28);
	
	var _ExceedBanner2 = _interopRequireDefault(_ExceedBanner);
	
	__webpack_require__(432);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Export Template for use in CMS preview
	var EmploymentOpportunitiesTemplate = exports.EmploymentOpportunitiesTemplate = function EmploymentOpportunitiesTemplate(_ref) {
	  var title = _ref.title,
	      subtitle = _ref.subtitle,
	      footerSettings = _ref.footerSettings,
	      body = _ref.body,
	      meta = _ref.meta;
	
	
	  return _react2.default.createElement(
	    'main',
	    { className: 'EmploymentOpportunities background-dots' },
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      { defaultTitle: meta && meta.title || title + ' | Great Start ELC' },
	      meta && _react2.default.createElement('meta', { name: 'description', content: meta.description }),
	      meta && _react2.default.createElement('link', { rel: 'canonical', href: meta.canonical })
	    ),
	    _react2.default.createElement(_PageHeader2.default, { title: title, subtitle: subtitle }),
	    _react2.default.createElement(
	      'section',
	      { className: 'section background-clouds' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container content' },
	        _react2.default.createElement(_Content2.default, { source: body }),
	        _react2.default.createElement(_ApplicationFormSection2.default, null)
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'section thin' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(_ExceedBanner2.default, { footerSettings: footerSettings })
	      )
	    )
	  );
	};
	
	var EmploymentOpportunities = function EmploymentOpportunities(_ref2) {
	  var _ref2$data = _ref2.data,
	      page = _ref2$data.page,
	      footerSettings = _ref2$data.footerSettings;
	  return _react2.default.createElement(EmploymentOpportunitiesTemplate, _extends({}, page, page.frontmatter, { body: page.html, footerSettings: footerSettings }));
	};
	
	exports.default = EmploymentOpportunities;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-employment-opportunities-js-8126d8c02f1635d0cf3c.js